/* eslint-disable no-console */
import Cookies from 'universal-cookie';
import {
  BOOKING_TOKEN,
  RESPONSE_ERROR,
  RESPONSE_SUCCESS,
  SESSION_STORAGE_CURRENT_BOOKING,
} from '../constants';

const cookies = new Cookies();
export const MYRES = 'myres';

export const getReservationInformation = () => {
  try {
    const sessionStorageString = sessionStorage.getItem(SESSION_STORAGE_CURRENT_BOOKING);
    const currentBookingInfo = JSON.parse(sessionStorageString);
    if (currentBookingInfo) {
      return {
        bookingId: currentBookingInfo.id,
        sailDate: currentBookingInfo.sailing?.sailDate,
        shipCode: currentBookingInfo.sailing?.itinerary?.ship?.code,
        lastName: currentBookingInfo.guests?.[0]?.lastName,
        packageCode: currentBookingInfo.sailing?.itinerary?.code,
      };
    }
    // eslint-disable-next-line no-empty
  } catch (error) {}
  return null;
};

export function sendTrackingParams(trackingParamsToSend, isView = true) {
  if (window.utag) {
    if (isView) {
      window.utag.view(trackingParamsToSend);
    } else {
      window.utag.link(trackingParamsToSend);
    }
  } else {
    // This is necessary because utag.js script is loaded asynchronously
    setTimeout(() => sendTrackingParams(trackingParamsToSend, isView), 1000);
  }
}

export function trackView(trackingParams) {
  const token = sessionStorage.getItem(BOOKING_TOKEN);
  const country = cookies.get('country');

  if (token !== null) {
    const reservation = getReservationInformation();
    if (reservation) {
      const { bookingId, sailDate, shipCode } = reservation;
      sendTrackingParams({
        bookingId,
        country,
        sailDate,
        shipCode,
        ...trackingParams,
      });
    }
  } else {
    sendTrackingParams({
      country,
      ...trackingParams,
    });
  }
}

function getIdByClass(target) {
  if (target.className.includes('guest-info')) return 'guestInfo';
  if (target.className.includes('dining')) return 'dining';
  if (target.className.includes('preferences')) return 'preferences';

  return null;
}

function addSiteSectionTrackView(trackingParams) {
  trackView({ siteSection: MYRES, ...trackingParams });
}

export function trackPageView({
  currency = 'USD',
  language = 'en',
  isAffirm = false,
  isGALoggedIn = false,
  isUpgradeElegible = false,
  showFlightComponent = false,
  isFlightReserved = false,
  cancelFlight = false,
  changeFlight = false,
  bookingInfo,
  isBookAdditionalFlight = false,
  reservationChannel,
  splitExManageRes,
}) {
  const page = window.location.pathname.split('/').pop();
  const siteType = 'desktop';
  const offersAvailableArray = [
    isUpgradeElegible ? 'roomUpgrade' : '',
    showFlightComponent ? 'air' : '',
    isAffirm ? 'affirm' : '',
    cancelFlight ? 'cancelFlight' : '',
    changeFlight ? 'changeFlight' : '',
    isBookAdditionalFlight ? 'addAdditional' : '',
    isFlightReserved ? 'manageFlight' : '',
  ];
  const offersAvailableFiltered = offersAvailableArray.filter(Boolean);
  const baseParams = {
    pageName: `${MYRES}:${page}`,
    currency: currency || '',
    language,
    siteType,
    loginStatus: isGALoggedIn ? 'Logged In' : 'Anonymous',
    reservationChannel,
    splitExManageRes,
  };
  const params = { ...baseParams };

  if (offersAvailableFiltered.length > 0) {
    Object.assign(params, {
      offersAvailable: offersAvailableFiltered.join(', '),
    });
  }

  if (bookingInfo?.token) {
    Object.assign(params, {
      remainingBal: bookingInfo?.price?.balanceDue || 0,
      prodcategory: ['BOOKING'],
      prodQuantity: ['1'],
      prodCost: [bookingInfo?.price?.total.toString()],
      prodSku: [bookingInfo?.sailing?.itinerary?.code],
      destination: bookingInfo?.sailing?.itinerary?.destination?.name.toUpperCase(),
      departurePort: bookingInfo?.sailing?.itinerary?.departurePort?.name,
      paymentOptions: bookingInfo?.price?.inFinal ? 'final' : 'notFinal',
      bookingPassengers: bookingInfo?.guests?.length || 0,
      bookingDesc: [bookingInfo?.sailing?.itinerary?.description],
      departureDate: bookingInfo?.sailing?.sailDate,
      eventType: 'reservationView',
      bookingStatus: bookingInfo?.status.toLowerCase(),
    });
  }

  return addSiteSectionTrackView(params);
}

export function trackPreferencesView(e) {
  const event = e || window.event;
  const target = event.target || event.srcElement;
  const trackingId = target.id !== '' ? target.id : getIdByClass(target);
  switch (trackingId) {
    case 'guestInfo':
    case 'menuGuestInfo':
    case 'preferences':
      addSiteSectionTrackView({ pageName: `${MYRES}:room1:guest_info` });
      break;
    case 'dining':
    case 'menuDining':
      addSiteSectionTrackView({
        pageName: `${MYRES}:room1:dining_preferences`,
      });
      break;
    case 'menuBedding':
      addSiteSectionTrackView({
        pageName: `${MYRES}:room1:bedding_preferences`,
      });
      break;
    case 'menuPrePaidGratuities':
      addSiteSectionTrackView({
        pageName: `${MYRES}:room1:prepaid_gratuities`,
      });
      break;
    case 'menuTravelProtection':
      addSiteSectionTrackView({ pageName: `${MYRES}:room1:travel_protection` });
      break;
    default:
      // eslint-disable-next-line no-console
      console.warn('No tracking');
  }
  return trackingId;
}

export function trackPaymentView() {
  addSiteSectionTrackView({ pageName: `${MYRES}:room1:make_a_payment` });
}

export function trackPaymentCTA(payment, responseMsg, type, currentBookingInfo, cardType) {
  const bookingId = currentBookingInfo?.id;
  const sailDate = currentBookingInfo?.sailing?.sailDate;
  const shipCode = currentBookingInfo?.sailing?.itinerary?.ship?.code;
  if (type === RESPONSE_ERROR) {
    sendTrackingParams(
      {
        myresInteractions: `${MYRES}:payment failed`,
        makePaymentAction: `${MYRES}:payment failed`,
        makePaymentType: payment?.remainingBalance > 0 ? 'Partial Paid' : 'Full Paid',
        paymentAmount: payment?.amount,
        remainingBal: payment?.remainingBalance,
        eventType: 'interaction',
        interaction: 'myres:payment failed',
        paymentMethod: cardType,
        bookingId,
        sailDate,
        shipCode,
      },
      false,
    );
  } else {
    sendTrackingParams(
      {
        myresInteractions: `${MYRES}:payment ${RESPONSE_SUCCESS}`,
        makePaymentAction: `${MYRES}:payment ${RESPONSE_SUCCESS}`,
        makePaymentType: payment?.remainingBalance > 0 ? 'Partial Paid' : 'Full Paid',
        paymentAmount: payment?.amount,
        eventType: 'interaction',
        interaction: 'myres:payment success',
        remainingBal: payment?.remainingBalance,
        paymentMethod: cardType,
        bookingId,
        sailDate,
        shipCode,
      },
      false,
    );
  }
}

export function trackFindReservationCTA(responseMsg, type, currency, reservationChannel = '') {
  if (type === RESPONSE_ERROR) {
    sendTrackingParams(
      {
        myresInteractions: `${MYRES}:find_my_reservation:${RESPONSE_ERROR}:${responseMsg}`,
      },
      false,
    );
  } else {
    const token = sessionStorage.getItem(BOOKING_TOKEN);
    if (token !== null) {
      const reservation = getReservationInformation();
      if (reservation) {
        sendTrackingParams(
          {
            currency: currency || '',
            myresInteractions: `${MYRES}:find_my_reservation:${RESPONSE_SUCCESS}`,
            reservationNumber: reservation.bookingId,
            myResShip: reservation.shipCode,
            myresSaildate: reservation.sailDate,
            reservationChannel,
          },
          false,
        );
        return reservation;
      }
    }
  }
  return null;
}

export function trackAddFlightsCTA(currency) {
  sendTrackingParams(
    {
      eventType: 'interactions',
      interaction: 'airbooking:addflights',
      currency: currency || '',
    },
    false,
  );
}

export function trackSuccesGiftCard(amount) {
  sendTrackingParams(
    {
      eventType: 'interactions',
      interaction: `amend:giftcardvalidation:success`,
      giftCardAmount: amount,
    },
    false,
  );
}
export function trackremoveGiftCard() {
  sendTrackingParams(
    {
      eventType: 'interactions',
      interaction: `amend:giftcard:removed`,
    },
    false,
  );
}

export function trackError(errorType, currentTabTraking) {
  sendTrackingParams(
    {
      eventType: 'interactions',
      interaction: `${currentTabTraking}:${errorType}`,
    },
    false,
  );
}

export function trackSuccesGiftCardPayment(trackInformation) {
  const creditCardType =
    trackInformation && trackInformation.creditCardType && trackInformation.creditCardType;

  const CARD_TYPES = {
    AX: 'mericanexpress',
    DC: 'dinersclub',
    DS: 'discover',
    JC: 'jcb',
    MC: 'mastercard',
    VA: 'visa',
  };

  const cardTypeName = CARD_TYPES[creditCardType];

  sendTrackingParams({
    eventType: 'interactions',
    interaction: 'amend:giftcard:applied',
    totalGiftCardAmntApplied: trackInformation.gCPaymentAmount,
    paymentMethod: creditCardType ? `${cardTypeName}:giftcard` : 'giftcard',
  });
}

export function trackAffirmInteraction(type) {
  sendTrackingParams(
    {
      eventType: 'interactions',
      interaction: `affirm:${type}`,
    },
    false,
  );
}

export function trackAffirmSuccess(amount) {
  sendTrackingParams({
    affirmAmount: amount,
    paymentMethod: 'affirm',
  });
}

export function trackInteraction(interaction) {
  sendTrackingParams(
    {
      eventType: 'interactions',
      interaction,
    },
    false,
  );
}
